import React, { CSSProperties } from 'react';
import { TrackingInfoEvent } from '../../../../../../../__generated__/loma';
import { useHackStyle } from '../hooks/useHackStyle';

export interface TrackingEventDescriptionProps {
  formattedDescription?: TrackingInfoEvent['formattedDescription'];
  description?: TrackingInfoEvent['description'];
  s?: CSSProperties;
}

const TrackingEventDescription = ({
  formattedDescription,
  description,
  s,
}: TrackingEventDescriptionProps) => {
  const { cssClass } = useHackStyle();

  const descriptionElement =
    formattedDescription &&
    formattedDescription.format === 'HTML' &&
    formattedDescription.value ? (
      <p
        className={cssClass}
        style={{ ...s, marginTop: '0' }}
        dangerouslySetInnerHTML={{
          __html: formattedDescription.value,
        }}
      />
    ) : (
      <p style={{ ...s, marginTop: '0' }}>{description}</p>
    );

  return descriptionElement;
};

export default TrackingEventDescription;
